import React from 'react';

import AppRouter from '@app/router/AppRouter';
import antdGlobalStyles from '@app/style/antdGlobalStyle';
import GlobalStyle from '@app/style/globalStyles';
import { useAnalytics } from '@hooks/shared/useAnalytics';
import { useLanguage } from '@hooks/shared/useLanguage';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { ConfigProvider } from 'antd';
import enUS from 'antd/lib/locale/en_US';
import ukUA from 'antd/lib/locale/uk_UA';
import 'dayjs/locale/uk';
import '@ant-design/v5-patch-for-react-19';
import i18n from 'i18next';

function App() {
	const { language } = useLanguage();
	useAnalytics();

	let locate = ukUA;
	if (language === 'en') {
		locate = enUS;
	}

	document.documentElement.lang = i18n.language;

	return (
		<>
			<ConfigProvider
				locale={locate}
				theme={{
					token: { ...antdGlobalStyles },
					hashed: false,
				}}>
				<AppRouter />
			</ConfigProvider>
			<GlobalStyle />
			{process.env.NODE_ENV !== 'production' && <ReactQueryDevtools initialIsOpen={false} />}
		</>
	);
}

export default App;
